import React from 'react';
import { PageContext } from '../contexts/page-context';

// This should be added in front of all relative urls so that the /es/ links point to /es/ links
const useLangRelPathBase = () => {
  const { pageProps } = React.useContext(PageContext);
  if (pageProps?.pageContext?.additionalLanguage) {
    return '/' + pageProps?.pageContext?.additionalLanguage;
  } else {
    return '';
  }
};

export default useLangRelPathBase;
